import { render } from "./StatsSkeleton.vue?vue&type=template&id=f91c3f18&scoped=true"
import script from "./StatsSkeleton.vue?vue&type=script&lang=js"
export * from "./StatsSkeleton.vue?vue&type=script&lang=js"

import "./StatsSkeleton.vue?vue&type=style&index=0&id=f91c3f18&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f91c3f18"]])

export default __exports__